<script lang="ts" setup>
import { ULink } from '#components'

defineProps({
  isLink: {
    default: false,
    type: Boolean,
  },
})

const localePath = useLocalePath()
</script>

<template>
  <Component
    :is="isLink ? ULink : 'div'"
    class="w-40 sm:w-48"
    :to="isLink ? localePath('index') : undefined"
  >
    <UColorModeImage
      alt="The Companies API Logo"
      class="select-none"
      dark="/images/bases/BaseLogo/logo-dark.svg"
      light="/images/bases/BaseLogo/logo-light.svg"
    />
  </Component>
</template>
